module.exports = __webpack_public_path__ + "img/logo.31d5d380.svg";